import { AxiosInstance } from 'axios'

import { apiPaths } from '@percent/partner-dashboard/services/apiPaths'
import { PBPListResponse } from '@percent/partner-dashboard/services/types/pbpResponses.types'
import { GetSubsidiariesProps, Subsidiary } from './subsidiariesService.types'

type SubsidiariesServiceCapabilities = {
  percentClient: AxiosInstance
}

export const subsidiariesService = ({ percentClient }: SubsidiariesServiceCapabilities) => ({
  getSubsidiaries: (params: GetSubsidiariesProps) =>
    percentClient.get<PBPListResponse<Subsidiary>>(apiPaths.v1Subsidiaries, { params })
})
